
import { useDashboardStore } from '@/store/dashboard'
import { computed, defineComponent, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import BaseInput from '@/components/BaseInput.vue'
import BaseButton from '@/components/BaseButton.vue'

export default defineComponent({
  name: 'quiz-info',
  components: { BaseInput, BaseButton },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useDashboardStore()
    const timeLimit = ref(0)
    const testName = ref('')
    const testDate = ref('21.12.2020')
    const testTime = ref('8:00')

    store.fetchQuiz(parseInt(route.params.id as string))

    function formatDate(timestamp: number) {
      return dayjs(timestamp).fromNow()
    }

    function startTest() {
      store.startQuiz(parseInt(route.params.id as string), timeLimit.value)
      router.push('/monitor-quiz/' + route.params.id)
    }

    async function deleteQuiz() {
      await store.deleteQuiz()
      router.push('/dashboard')
    }

    async function appointTest() {
      await store.appointQuiz(testDate.value, testTime.value, timeLimit.value)
      router.push('/dashboard')
    }

    async function changeTest() {
      router.push('/edit-quiz/' + route.params.id)
    }

    return {
      store,
      formatDate,
      startTest,
      timeLimit,
      deleteQuiz,
      testName,
      testDate,
      appointTest,
      testTime,
      changeTest,
      isDeletable: computed(() => testName.value !== store.currentQuiz!.name),
    }
  },
})
